import { atom } from "jotai";

import { NewGuestRoundInput } from "../../../../../hooks/saveChangesHooks/useSaveChangesToSingleSlotBooking/__generated__/useSaveChangesToSingleSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../../stores";

export const updatedNewGuestRoundsAtom = atom<NewGuestRoundInput[] | null>(
  (get) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return null;
    const rounds = currentBooking.rounds;
    const newGuestRounds = rounds?.filter(
      (r) => r.player?.clientType === "newGuest"
    );
    const input: NewGuestRoundInput[] = newGuestRounds?.map((r) => ({
      index: r.index,
      bookingIndex: r.bookingIndex,
      id: r.serverId,
      playerId: r.player?.id || null,
      courseLayoutId: r.type === "Golf" ? r.courseLayout?.id : null,
      transportationTypeId: r.type === "Golf" ? r.transportationType?.id : null,
      secondaryTransportationTypeId: r.secondaryTransportationType?.id,
      rateId: r.type === "Golf" ? r.roundRate?.id : r.rate?.id ?? null,
      name:
        r.player?.firstName || r.player?.lastName
          ? `${r.player.firstName ?? ""} ${r.player.lastName ?? ""}`.trim()
          : "",
      manualPaymentStatus: r.manualPaymentStatus ?? "AUTO_CHARGE",
    }));
    return input;
  }
);
